import Vue from 'vue';
import Vuex from 'vuex';
import 'es6-promise/auto'

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    enableAudio : false,
  },
})



// WEBPACK FOOTER //
// ./src/store/store.js